// extracted by mini-css-extract-plugin
module.exports = {"copyrightText":"Footer_copyrightText__39uAN","iconText":"Footer_iconText__3WDcE","link":"Footer_link__2MQgs"};